import { render, staticRenderFns } from "./CohostsSearch.vue?vue&type=template&id=9fe791c8&"
import script from "./CohostsSearch.vue?vue&type=script&lang=js&"
export * from "./CohostsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fe791c8')) {
      api.createRecord('9fe791c8', component.options)
    } else {
      api.reload('9fe791c8', component.options)
    }
    module.hot.accept("./CohostsSearch.vue?vue&type=template&id=9fe791c8&", function () {
      api.rerender('9fe791c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/CohostsSearch.vue"
export default component.exports